import { createFileRoute } from "@tanstack/react-router";
import { AdsPage } from "./annonser";

export const Route = createFileRoute("/en/listings")({
  head: () => ({
    meta: [
      { title: "All listings – buy second hand | Sellavo" },
      { name: "description", content: "Browse every listing on Sellavo and find second hand near you." },
      { property: "og:title", content: "All listings – buy second hand | Sellavo" },
      { property: "og:description", content: "Browse every listing on Sellavo and find second hand near you." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/listings" }],
  }),
  component: AdsPage,
});
